import { IconLayer, IconLayerProps } from "@deck.gl/layers";
import { LineString } from "geojson";
import { useMemo } from "react";

import { XYLocation } from "@nens/deck-gl";

export type Arrow = {
  position: XYLocation;
  angle: number;
};

function latLngToXY(lat: number, lng: number) {
  const R = 6371000; // Earth's radius in meters
  const x = (R * lng * Math.PI) / 180;
  const y = R * Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360));
  return { x, y };
}

const ICON_MAPPING = {
  arrow: { x: 0, y: 0, width: 51, height: 125, mask: true },
};

interface ArrowLayerProps extends Partial<IconLayerProps> {
  data: LineString[];
}

export const UseArrowLayer = ({ data, ...props }: ArrowLayerProps) => {
  const arrows = useMemo(
    () =>
      data.map(({ coordinates }: LineString) => {
        const [long1, lat1] = coordinates[0];
        const [long2, lat2] = coordinates[1];

        const center = [long1 + (long2 - long1) / 2, lat1 + (lat2 - lat1) / 2] as XYLocation;

        const { x: x1, y: y1 } = latLngToXY(lat1, long1);
        const { x: x2, y: y2 } = latLngToXY(lat2, long2);
        const angle = Math.atan2(y2 - y1, x2 - x1);

        return {
          position: center,
          angle: angle * (180 / Math.PI),
        };
      }),
    [data]
  );

  return new IconLayer({
    data: arrows,
    getPosition: (d: Arrow) => d.position,
    getAngle: (d: Arrow) => d.angle - 90,
    getIcon: () => "arrow",
    sizeUnits: "meters",
    getSize: 10,
    getColor: [0, 0, 0],
    iconAtlas: "./assets/images/arrowIcon.png",
    iconMapping: ICON_MAPPING,
    billboard: false,
    sizeMaxPixels: 100,
    ...props,
  } as IconLayerProps);
};
